import {ServerResponse, SesService} from '@spa/api';
import {FormGroup} from '@angular/forms';
import {BaseControl, Helper} from 'appShared/classes';

export abstract class BaseMarketDataForm {
    protected readonly sesService: SesService;
    public formGroup: FormGroup;
    public controls: BaseControl[];
    FORM_ELEMENT_CCOUNT: number;

    constructor(sesService: SesService) {
        this.sesService = sesService;
    }

    protected getFormPriceValueByKey(key: string): number {
        const formValue = this.formGroup.value[key];

        if (!formValue) {
            return 0;
        }

        return +Helper.getNonFormattedAmount(String(formValue));
    }

    abstract createRequest(): ServerResponse<boolean | any>;

    abstract initForm(): void;

    validateForm(messagesFunction: (controlsLabel?: string) => { [key: string]: string }): boolean {
        const statusesCheck = this.controls.map((control: BaseControl) => {
            const formControl = this.formGroup.controls[control.name];

            if (formControl && formControl.invalid) {
                control.errors = Object.keys(formControl.errors).map((key: string) => {
                    return messagesFunction(control.placeholder)[key];
                });

                return false;
            }

            return true;
        });

        return statusesCheck.indexOf(false) < 0;
    }
}
